import React, { useState } from 'react';
import { MapPin, Phone, X, ShieldCheck, FileText } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-gym-dark py-12 border-t border-gym-charcoalLight" data-id="element-86">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/oeddet9Q3MYGpU58ZCsPBn/logogym1.png" alt="Coach Pro Logo" className="h-20 w-auto object-contain mb-8 opacity-80 hover:opacity-100 transition-opacity" data-id="element-88" />

          <div className="space-y-3 mb-8 text-gray-400" data-id="element-89">
            <p className="font-medium flex items-center justify-center gap-2" data-id="element-90">
              <MapPin size={18} className="text-gym-gold shrink-0" data-id="element-91" />
              Av. Brígida Silva de Ochoa con Calle Angélica Palma 195, 2do piso,
              San Miguel, Lima
            </p>
            <p className="font-medium flex items-center justify-center gap-2" data-id="element-92">
              <Phone size={18} className="text-gym-gold shrink-0" data-id="element-93" />
              +51 915 013 918
            </p>
          </div>

          <p className="text-2xl font-heading font-bold text-gym-gold uppercase tracking-widest mb-12" data-id="element-94">
            Mente fuerte. Cuerpo imparable.
          </p>

          <div className="w-full pt-8 border-t border-gym-charcoalLight/50 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500 gap-4" data-id="element-95">
            <p data-id="element-96">
              &copy; {new Date().getFullYear()} Coach Pro Gimnasio San Miguel.
              Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-97">
              <button onClick={() => setActiveModal('privacy')} className="hover:text-gym-green transition-colors underline underline-offset-4" data-id="element-98">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="hover:text-gym-green transition-colors underline underline-offset-4" data-id="element-99">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-100">
        {activeModal && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-101" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 40
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 40
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] z-[101] bg-gym-charcoal border border-gym-charcoalLight rounded-2xl flex flex-col overflow-hidden shadow-2xl" data-id="element-102">
              {/* Modal Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-gym-charcoalLight shrink-0" data-id="element-103">
                <div className="flex items-center gap-3" data-id="element-104">
                  {activeModal === 'privacy' ? <ShieldCheck size={24} className="text-gym-green" data-id="element-105" /> : <FileText size={24} className="text-gym-gold" data-id="element-106" />}
                  <h2 className="text-xl font-heading font-bold text-white uppercase tracking-wider" data-id="element-107">
                    {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                  </h2>
                </div>
                <button onClick={() => setActiveModal(null)} className="w-10 h-10 flex items-center justify-center rounded-lg bg-gym-dark text-gray-400 hover:text-white hover:bg-gym-charcoalLight transition-colors" aria-label="Cerrar" data-id="element-108">
                  <X size={20} data-id="element-109" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="flex-1 overflow-y-auto px-6 py-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-110">
                {activeModal === 'privacy' ? <>
                    <p className="text-gray-400 text-xs uppercase tracking-wider" data-id="element-111">
                      Última actualización: Marzo 2026
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-112">
                      1. Información que Recopilamos
                    </h3>
                    <p data-id="element-113">
                      En Coach Pro Gimnasio San Miguel, recopilamos información
                      personal que nos proporcionas voluntariamente al
                      contactarnos por WhatsApp, registrarte para una clase
                      gratuita o inscribirte en nuestros servicios. Esta
                      información puede incluir tu nombre, número de teléfono,
                      dirección de correo electrónico y datos relacionados con
                      tu condición física.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-114">
                      2. Uso de la Información
                    </h3>
                    <p data-id="element-115">
                      Utilizamos tu información personal para: proporcionarte
                      nuestros servicios de entrenamiento y nutrición,
                      comunicarnos contigo sobre tu programa de entrenamiento,
                      enviarte información sobre promociones y eventos (con tu
                      consentimiento), y mejorar nuestros servicios.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-116">
                      3. Protección de Datos
                    </h3>
                    <p data-id="element-117">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado, alteración, divulgación o
                      destrucción. Tu información no será compartida con
                      terceros sin tu consentimiento expreso.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-118">
                      4. Tus Derechos
                    </h3>
                    <p data-id="element-119">
                      Tienes derecho a acceder, rectificar, cancelar u oponerte
                      al tratamiento de tus datos personales. Para ejercer estos
                      derechos, contáctanos al +51 915 013 918.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-120">
                      5. Contacto
                    </h3>
                    <p data-id="element-121">
                      Para cualquier consulta sobre nuestra política de
                      privacidad, escríbenos por WhatsApp al +51 915 013 918 o
                      visítanos en Av. Brígida Silva de Ochoa con Calle Angélica
                      Palma 195, 2do piso, San Miguel, Lima.
                    </p>
                  </> : <>
                    <p className="text-gray-400 text-xs uppercase tracking-wider" data-id="element-122">
                      Última actualización: Marzo 2026
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-123">
                      1. Aceptación de Términos
                    </h3>
                    <p data-id="element-124">
                      Al utilizar los servicios de Coach Pro Gimnasio San
                      Miguel, aceptas estos términos y condiciones en su
                      totalidad. Si no estás de acuerdo con alguno de estos
                      términos, te pedimos que no utilices nuestros servicios.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-125">
                      2. Servicios
                    </h3>
                    <p data-id="element-126">
                      Coach Pro ofrece servicios de entrenamiento en
                      musculación, entrenamiento funcional y orientación
                      nutricional. Los servicios están sujetos a disponibilidad
                      y pueden modificarse sin previo aviso.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-127">
                      3. Clase Gratuita
                    </h3>
                    <p data-id="element-128">
                      La clase gratuita de prueba está disponible para nuevos
                      clientes y está sujeta a disponibilidad de cupos. No
                      genera ningún compromiso de inscripción posterior. Cada
                      persona puede acceder a una sola clase gratuita.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-129">
                      4. Responsabilidad
                    </h3>
                    <p data-id="element-130">
                      El usuario es responsable de informar sobre cualquier
                      condición médica o limitación física antes de iniciar
                      cualquier programa de entrenamiento. Coach Pro no se hace
                      responsable por lesiones derivadas del incumplimiento de
                      las instrucciones del entrenador.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-131">
                      5. Membresías y Pagos
                    </h3>
                    <p data-id="element-132">
                      Las tarifas de membresía y servicios están disponibles en
                      nuestras instalaciones. Los pagos deben realizarse según
                      los plazos acordados. Las políticas de cancelación y
                      reembolso se informarán al momento de la inscripción.
                    </p>
                    <h3 className="text-lg font-bold text-white" data-id="element-133">
                      6. Conducta
                    </h3>
                    <p data-id="element-134">
                      Los miembros deben mantener una conducta respetuosa dentro
                      de las instalaciones. Coach Pro se reserva el derecho de
                      cancelar la membresía de cualquier persona que no cumpla
                      con las normas de convivencia del gimnasio.
                    </p>
                  </>}
              </div>

              {/* Modal Footer */}
              <div className="px-6 py-4 border-t border-gym-charcoalLight shrink-0" data-id="element-135">
                <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-gym-green hover:bg-gym-greenHover text-white font-bold rounded-full transition-colors uppercase tracking-wider text-sm" data-id="element-136">
                  Entendido
                </button>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}